export default "__VITE_ASSET__B2Q7RT2B__"